import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bi-data-warehousing',
  templateUrl: './bi-data-warehousing.component.html',
  styleUrls: ['./bi-data-warehousing.component.sass']
})
export class BiDataWarehousingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
